module.exports = __webpack_public_path__ + "static/media/lance-coury-photo-2.b1e93ce7.jpg";